import { ResourceAnalysis } from "../components/resource-analysis";
import { DocumentsSection } from "../components/side-panel-sections/documents-section";
import { SidePanelLayout } from "../components/side-panel-sections/side-panel-layout";
import { EncounterRowData } from "../tables/encounter";

export type EncounterSidePanelContentProps = {
  data: EncounterRowData;
};

export function EncounterSidePanelContent({ data }: EncounterSidePanelContentProps) {
  const dateRange =
    data.startDate !== "-" && data.endDate !== "-"
      ? `${data.startDate} to ${data.endDate}`
      : data.startDate !== "-"
      ? data.startDate
      : data.endDate;

  return (
    <SidePanelLayout title="Encounter" subtitle={data.type} metadata={dateRange}>
      <ResourceAnalysis />

      <DocumentsSection resources={[data.originalData]} resourceType="Encounter" />
    </SidePanelLayout>
  );
}
